import React, { useState, useEffect, Fragment } from 'react';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';
import AccountsReportExcel from './AccountsReportExcel';
import Spinner from 'react-bootstrap/Spinner';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const AccountsReport = ({ }) => {

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setLoading] = useState(false);

    const getDataAccountingAccountsReport = async () => {
        setLoading(true);
        let fechaInicial = moment(startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cajas-contables/reporte-cuentas-contables', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss')
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(response => {
            setLoading(false);
            AccountsReportExcel.exportExcel(response);
        }).catch(err => {
            setLoading(false);
            console.error(err);
        });
    }

    return (
        <Fragment>
            <Row>
                <Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <DatePicker
                                disableFuture
                                openTo="date"
                                label="Fecha Inicial"
                                variant="inline"
                                autoOk={true}
                                views={["year", "month", "date"]}
                                value={startDate}
                                onChange={(date) => {
                                    setStartDate(date);
                                }}
                                className='medical-material-form__field'
                                animateYearScrolling
                                format="yyyy/MM/D"
                            />
                        </ThemeProvider>
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <DatePicker
                                disableFuture
                                openTo="date"
                                label="Fecha Final"
                                variant="inline"
                                views={["year", "month", "date"]}
                                value={endDate}
                                autoOk={true}
                                onChange={(date) => {
                                    setEndDate(date);
                                }}
                                className='medical-material-form__field'
                                animateYearScrolling
                                format="yyyy/MM/D"
                            />
                        </ThemeProvider>
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                    <Button
                        disabled={false}
                        style={{ marginTop: 10, marginRight: 10 }}
                        variant="contained"
                        className="btn btn-primary btn-sm text-white"
                        onClick={() => {
                            getDataAccountingAccountsReport();
                        }}
                    >
                        Generar Excel
                    </Button>
                    {loading == true ? <Spinner animation="border" variant="success" /> : null}
                </Col>
            </Row>
        </Fragment>
    );
}

export default AccountsReport;
